import React from 'react';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../containers/PageBuilder/Field';
import BlockBuilder from '../../containers/PageBuilder/BlockBuilder';
import SectionContainer from '../../containers/PageBuilder/SectionBuilder/SectionContainer';

import MarqueeCard from './MarqueeCard';
import css from './SectionMarquee.module.css';

// Sekunden je Kachel fuer einen vollen Umlauf. Mehr Kacheln = laengere
// Runde, aber immer dasselbe Lauftempo (rund 45 Pixel pro Sekunde).
const SECONDS_PER_BLOCK = 7;

/**
 * FairwayBid: Abschnitt, der seine Kacheln einzeilig und automatisch
 * durchlaufen laesst (Laufband). Aufbau und Felder entsprechen dem
 * Standard-Abschnitt "columns", nur die Anordnung der Kacheln ist anders.
 *
 * Die Kacheln werden zweimal gerendert. Das Band wandert um genau die
 * Haelfte seiner Breite und springt dann zurueck - dadurch entsteht ein
 * nahtloser Umlauf ohne Sprung im Bild. Die zweite Reihe ist eine reine
 * Bildkopie und fuer Screenreader ausgeblendet.
 *
 * Anhalten: beim Ueberfahren mit der Maus und sobald ein Element im Band
 * den Tastaturfokus hat. Wer im Betriebssystem weniger Bewegung
 * eingestellt hat (prefers-reduced-motion), bekommt statt der Animation
 * ein normal scrollbares Band.
 */
const SectionMarquee = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    title,
    description,
    appearance,
    callToAction,
    blocks = [],
    options,
  } = props;

  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  // Die Kacheln im Band werden als Anfragen-Karten gerendert, nicht als
  // Standardbloecke. Alles andere aus options bleibt erhalten.
  const blockOptions = {
    ...options,
    blockComponents: {
      ...(options?.blockComponents || {}),
      defaultBlock: { component: MarqueeCard },
    },
  };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);
  const hasBlocks = blocks?.length > 0;
  // Ein Umlauf entspricht genau einer Reihe, also einmal allen Kacheln.
  const duration = `${Math.max(blocks.length, 1) * SECONDS_PER_BLOCK}s`;

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={rootClassName}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasHeaderFields ? (
        <header className={defaultClasses.sectionDetails}>
          <Field data={title} className={defaultClasses.title} options={fieldOptions} />
          <Field data={description} className={defaultClasses.description} options={fieldOptions} />
          <Field data={callToAction} className={defaultClasses.ctaButton} options={fieldOptions} />
        </header>
      ) : null}

      {hasBlocks ? (
        <div className={classNames(css.viewport)}>
          <div className={css.track} style={{ animationDuration: duration }}>
            <div className={css.row}>
              <BlockBuilder
                ctaButtonClass={defaultClasses.ctaButton}
                blocks={blocks}
                sectionId={sectionId}
                responsiveImageSizes="(max-width: 767px) 78vw, 320px"
                options={blockOptions}
              />
            </div>
            <div className={css.row} aria-hidden="true">
              <BlockBuilder
                ctaButtonClass={defaultClasses.ctaButton}
                blocks={blocks}
                sectionId={`${sectionId}-kopie`}
                responsiveImageSizes="(max-width: 767px) 78vw, 320px"
                options={blockOptions}
              />
            </div>
          </div>
        </div>
      ) : null}
    </SectionContainer>
  );
};

export default SectionMarquee;
